export default "__VITE_ASSET__c9293802__$_?react__"